import { persistReducer, createTransform, createMigrate } from "redux-persist";
import storage from "redux-persist/lib/storage";
import autoMergeLevel2 from "redux-persist/lib/stateReconciler/autoMergeLevel2";
import { rootReducer } from "./redux/store";
import { resetState } from "./redux/modules/_BETA/utils";
import { INITIAL_STATE as actionsUIState } from "./redux/modules/_BETA/actionsUI";

// ! TODO: Remove redux persist!!!

/**
 * Prevents session-specific keys from being
 * persisted from the `auth' branch of the store
 */
const blacklistAuthTransform = createTransform((inboundState, key) => {
  if (key !== "auth") return inboundState;

  return {
    ...inboundState,
    loaded: false,
    loading: false,
    loggingIn: false,
    loggingOut: false,
    user: {
      ...inboundState.user,
      portfolio: { projects: [], sites: [] },
    },
  };
});

const blacklistInsightsTransform = createTransform((inboundState, key) => {
  if (key !== "insights") return inboundState;

  // If e2e test, set showSnoozed default to true
  const showSnoozed =
    window.Cypress && window.Cypress.env("user")
      ? true
      : inboundState.showSnoozed;

  return {
    ...inboundState,
    loading: false,
    ready: false,
    hasLoaded: false,
    raw: [],
    insights: [],
    siteGroups: undefined,
    composed: undefined,
    error: undefined,
    showSnoozed,
  };
});

const blacklistSelectionsTransform = createTransform((inboundState, key) => {
  if (key !== "betaSelections") return inboundState;

  return {
    ...inboundState,
    activeProject: {
      jira_key: "",
      sites: [],
      skysparkURL: "",
    },
    activeSite: { label: "", id: "", syncoId: undefined },
  };
});

const migrations = {
  0: (state) => resetState(state),
  1: (state) => resetState(state),
  // Clear old column state values that may be invalid
  2: (state) => ({
    ...state,
    betaEquipUI: undefined,
    betaRuleUI: undefined,
    betaActionsUI: actionsUIState,
  }),
  3: (state) => ({
    ...state,
    betaEquipUI: undefined,
    betaRuleUI: undefined,
    betaActionsUI: actionsUIState,
  }),
  4: (state) => ({
    ...state,
    betaRuleUI: undefined,
    betaActionsUI: actionsUIState,
  }),
};

// NOTE: If introducing structural changes to persisted store,
// increment version number by 1
// Only increment version number when absolutely necessary
// WARNING: This will force all users to be logged out on next insite load
// DO NOT decrement version number
export const PERSIST_CONFIG = {
  version: 4,
  key: "state",
  storage,
  whitelist: [
    "betaSelections",
    "auth",
    "betaEquipUI",
    "betaRuleUI",
    "betaActionsUI",
    "insights",
    "search",
  ],
  migrate: createMigrate(migrations, { debug: false }),
  transforms: [
    blacklistAuthTransform,
    blacklistInsightsTransform,
    blacklistSelectionsTransform,
  ],
  stateReconciler: autoMergeLevel2,
};

export const persistedReducer = persistReducer(PERSIST_CONFIG, rootReducer);
